/**
 * Bonscan Clarification API
 * OpenAPI contract for Bonscan clarification endpoints consumed by client applications.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateClarificationRequest { 
    /**
     * Member key code. The backend accepts UUID, numeric, or 10-char alphanumeric values.
     */
    keyCode?: string;
    keyCodeType?: CreateClarificationRequest.KeyCodeTypeEnum;
    bonID?: string;
    externalStoreID?: string;
    dateTime?: string;
    /**
     * Receipt total amount. Precision checks are enforced by service validation.
     */
    total?: number;
    /**
     * Base64-encoded receipt image
     */
    image: string;
}
export namespace CreateClarificationRequest {
    export type KeyCodeTypeEnum = 'ID' | 'CARDCODE' | 'APPCODE' | 'EXTERNALCODE';
    export const KeyCodeTypeEnum = {
        Id: 'ID' as KeyCodeTypeEnum,
        Cardcode: 'CARDCODE' as KeyCodeTypeEnum,
        Appcode: 'APPCODE' as KeyCodeTypeEnum,
        Externalcode: 'EXTERNALCODE' as KeyCodeTypeEnum
    };
}


